export default {
    "goal": "Mål.",
    "goal_team_only": "{{score}}Mål {{scoring_team}}!",
    "goal_team_player": "{{score}}Mål {{scoring_team}}! Scoring av {{scoring_player}}.",
    "own_goal_team_player": "{{score}}Mål {{scoring_team}}. Selvmål av {{scoring_player}}.",

    "yellow_card": "Gult kort.",
    "yellow_card_team_only": "Gult kort {{team}}.",
    "yellow_card_team_player": "Gult kort {{team}}: {{player}}.",

    "red_card": "Rødt kort.",
    "red_card_team_only": "Rødt kort {{team}}.",
    "red_card_team_player": "Rødt kort {{team}}: {{player}}.",

    "penalty": "Straffespark.",
    "penalty_by_team": "Straffespark, {{team}}.",

    "phase_kickoff": "Avspark.",
    "kickoff_1st_half": "Avspark første omgang.",
    "kickoff_2nd_half": "Avspark andre omgang.",
    "kickoff_1st_overtime": "Avspark første ekstraomgang.",
    "kickoff_2nd_overtime": "Avspark andre ekstraomgang.",
    "start_of_penalties": "Straffesparkkonkurranse.",

    "phase_end": "Pause.",
    "end_1st_half": "Pause.",
    "end_2nd_half": "Pause før ekstraomganger.",
    "end_1st_overtime": "Pause mellom ekstraomganger.",
    "end_2nd_overtime": "Pause før straffesparkkonkurranse.",

    "game_over": "Kampen over.",
    "game_over_1": "Kampen over, {{winning_team}} tar seieren på {{stadium}}. {{score_home}}-{{score_visiting}}",
    "game_over_2": "Kampen over, resultatet uavgjort på {{stadium}}. {{score_home}}-{{score_visiting}}",
    "game_over_3": "Kampen over, {{winning_team}} tar seieren. {{score_home}}-{{score_visiting}}",
    "game_over_4": "Kampen over, resultatet uavgjort. {{score_home}}-{{score_visiting}}",

    "shot": "Skudd",
    "blocked_shot": "Blokkert skudd",
    "shot_on_goal": "Skudd på mål",
    "shot_wide": "Skudd utenfor mål",
    "shot_on_bar": "Skudd i tverrligeren",
    "shot_on_post": "Skudd i stolpen",

    "blocked_shot_team": "Skudd for {{team}}. Skuddet blokkert.",
    "blocked_shot_team_player": "Skudd av {{player}}, {{team}}. Skuddet blokkert.",

    "heading": "Heading",
    "heading_on_goal": "Heading på mål",
    "heading_wide": "Heading utenfor",
    "heading_on_bar": "Heading i tverrligeren",
    "heading_on_post": "Heading i stolpen",

    "penalty_miss": "Straffebom",

    "shot_by_team": "{{shot_description}} for {{team}}.",
    "shot_by_player": "{{shot_description}} av {{player}}, {{team}}.",

    "offside": "Offside.",
    "offside_by_team": "Offside, {{team}}.",
    "offside_by_player": "{{player}} offside, {{team}}.",

    "corner": "Hjørnespark.",
    "corner_by_team": "Hjørnespark, {{team}}.",

    "throw_in": "Innkast.",
    "throw_in_by_team": "Innkast, {{team}}.",

    "save": "Redning.",
    "save_by_team": "Redning, {{team}}.",

    "free_kick": "Frispark.",
    "free_kick_by_team": "Frispark, {{team}}.",

    "injury": "Skade.",

    "interesting_event": "Interessant hendelse.",

    "substitution": "Bytte.",
    "substitution_team": "Bytte, {{team}}.",
    "substitution_player_in_out": "{{player_out}} ut, {{player_in}} inn.",

    "medical_assistance": "Medisinsk assistanse.",
    "medical_assistance_player": "Medisinsk assistanse, {{player}}."
}


// WEBPACK FOOTER //
// ./src/js/include/translations/Norwegian.js